import css from 'styled-jsx/css'
import { colors } from 'theme'

export default css.global`
  @charset "UTF-8";
  /*!
  Ionicons, v2.0.0
  Created by Ben Sperry for the Ionic Framework, http://ionicons.com/
  https://twitter.com/benjsperry  https://twitter.com/ionicframework
  MIT License: https://github.com/driftyco/ionicons

  Android-style icons originally built by Google’s
  Material Design Icons: https://github.com/google/material-design-icons
  used under CC BY http://creativecommons.org/licenses/by/4.0/
  Modified icons to fit ionicon’s grid from original.
*/

  .image-gallery-fullscreen-button::before,
  .image-gallery-play-button::before,
  .image-gallery-left-nav::before,
  .image-gallery-right-nav::before {
    display: inline-block;
    font-family: 'Ionicons';
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    text-rendering: auto;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .image-gallery {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    display: flex;
    align-items: center;
  }
  .image-gallery.fullscreen-modal {
    background: ${colors.black};
    bottom: 0;
    height: 100%;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 5;
  }
  .image-gallery.fullscreen-modal .image-gallery-content {
    top: 50%;
    transform: translateY(-50%);
  }

  .image-gallery-content {
    position: relative;
    line-height: 0;
    top: 0;
    width: 100%;
  }
  .image-gallery-content.fullscreen {
    background: ${colors.black};
    width: 100%;
  }
  .image-gallery-content.fullscreen .image-gallery-slide {
    background: ${colors.black};
  }

  .image-gallery-slide-wrapper {
    position: relative;
  }
  .image-gallery-slide-wrapper.left,
  .image-gallery-slide-wrapper.right {
    display: inline-block;
    width: calc(100% - 113px);
  }
  @media (max-width: 768px) {
    .image-gallery-slide-wrapper.left,
    .image-gallery-slide-wrapper.right {
      width: calc(100% - 84px);
    }
  }

  .image-gallery-fullscreen-button,
  .image-gallery-play-button,
  .image-gallery-left-nav,
  .image-gallery-right-nav {
    appearance: none;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    outline: none;
    position: absolute;
    z-index: 4;
  }
  .image-gallery-fullscreen-button::before,
  .image-gallery-play-button::before,
  .image-gallery-left-nav::before,
  .image-gallery-right-nav::before {
    color: ${colors.white};
    line-height: 0.7;
    text-shadow: 0 2px 2px ${colors.charcoalBlack};
    transition: color 0.2s ease-out;
  }
  .image-gallery-fullscreen-button:hover::before,
  .image-gallery-play-button:hover::before,
  .image-gallery-left-nav:hover::before,
  .image-gallery-right-nav:hover::before {
    color: ${colors.indigo};
  }
  @media (max-width: 768px) {
    .image-gallery-fullscreen-button:hover::before,
    .image-gallery-play-button:hover::before,
    .image-gallery-left-nav:hover::before,
    .image-gallery-right-nav:hover::before {
      color: ${colors.white};
    }
  }

  .image-gallery-fullscreen-button,
  .image-gallery-play-button {
    bottom: 0;
  }
  .image-gallery-fullscreen-button::before,
  .image-gallery-play-button::before {
    font-size: 2.7em;
    padding: 15px 20px;
    text-shadow: 0 1px 1px ${colors.charcoalBlack};
  }
  @media (max-width: 768px) {
    .image-gallery-fullscreen-button::before,
    .image-gallery-play-button::before {
      font-size: 2.4em;
    }
  }
  @media (max-width: 480px) {
    .image-gallery-fullscreen-button::before,
    .image-gallery-play-button::before {
      font-size: 2em;
    }
  }
  .image-gallery-fullscreen-button:hover::before,
  .image-gallery-play-button:hover::before {
    color: ${colors.white};
    transform: scale(1.1);
  }
  @media (max-width: 768px) {
    .image-gallery-fullscreen-button:hover::before,
    .image-gallery-play-button:hover::before {
      transform: none;
    }
  }

  .image-gallery-fullscreen-button {
    right: 0;
  }
  .image-gallery-fullscreen-button::before {
    content: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ4OS4zIDQ4OS4zIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODkuMyA0ODkuMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiPgo8Zz4KCTxnPgoJCTxwYXRoIGQ9Ik00NzYuOTUsMEgxMi4zNWMtNi44LDAtMTIuMiw1LjUtMTIuMiwxMi4yVjIzNWMwLDYuOCw1LjUsMTIuMiwxMi4yLDEyLjJzMTIuMy01LjUsMTIuMy0xMi4yVjI0LjVoNDQwLjJ2NDQwLjJoLTIxMS45ICAgIGMtNi44LDAtMTIuMyw1LjUtMTIuMywxMi4zczUuNSwxMi4zLDEyLjMsMTIuM2gyMjRjNi44LDAsMTIuMy01LjUsMTIuMy0xMi4zVjEyLjNDNDg5LjI1LDUuNSw0ODMuNzUsMCw0NzYuOTUsMHoiIGZpbGw9IiM5YzljOWMiLz4KCQk8cGF0aCBkPSJNMC4wNSw0NzYuOWMwLDYuOCw1LjUsMTIuMywxMi4yLDEyLjNoMTcwLjRjNi44LDAsMTIuMy01LjUsMTIuMy0xMi4zVjMwNi42YzAtNi44LTUuNS0xMi4zLTEyLjMtMTIuM0gxMi4zNSAgICBjLTYuOCwwLTEyLjIsNS41LTEyLjIsMTIuM3YxNzAuM0gwLjA1eiBNMjQuNTUsMzE4LjhoMTQ1Ljl2MTQ1LjlIMjQuNTVWMzE4Ljh6IiBmaWxsPSIjOWM5YzljIi8+CgkJPHBhdGggZD0iTTIyMi45NSwyNjYuM2MyLjQsMi40LDUuNSwzLjYsOC43LDMuNnM2LjMtMS4yLDguNy0zLjZsMTM4LjYtMTM4Ljd2NzkuOWMwLDYuOCw1LjUsMTIuMywxMi4zLDEyLjNzMTIuMy01LjUsMTIuMy0xMi4zICAgIFY5OC4xYzAtNi44LTUuNS0xMi4zLTEyLjMtMTIuM2gtMTA5LjVjLTYuOCwwLTEyLjMsNS41LTEyLjMsMTIuM3M1LjUsMTIuMywxMi4zLDEyLjNoNzkuOUwyMjIuOTUsMjQ5ICAgIEMyMTguMTUsMjUzLjgsMjE4LjE1LDI2MS41LDIyMi45NSwyNjYuM3oiIGZpbGw9IiM5YzljOWMiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K");
    /* content: ''; */
  }
  .image-gallery-fullscreen-button.active::before {
    /* content: ''; */
    content: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBoZWlnaHQ9IjMycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iMzJweCI+PHBhdGggZD0ibTE2OC4zNjMyODEgMzY0LjcxMDkzOHYzNi4xOTkyMThoMzB2LTg3LjY2NDA2MmgtODcuNjY0MDYydjMwaDM2LjcwNzAzMWwtODQuNjkxNDA2IDg0LjM3MTA5NCAyMS4xNzU3ODEgMjEuMjUzOTA2em0wIDAiIGZpbGw9IiM4YzhjOGMiLz48cGF0aCBkPSJtMzQzLjYzNjcxOSAzNjQuNzEwOTM4IDg0LjQ3MjY1NiA4NC4xNjAxNTYgMjEuMTc1NzgxLTIxLjI1MzkwNi04NC42OTE0MDYtODQuMzcxMDk0aDM2LjcwNzAzMXYtMzBoLTg3LjY2NDA2MnY4Ny42NjQwNjJoMzB6bTAgMCIgZmlsbD0iIzhjOGM4YyIvPjxwYXRoIGQ9Im0xMTAuNjk5MjE5IDE2OC43NTM5MDZ2MzBoODcuNjY0MDYydi04Ny42NjQwNjJoLTMwdjM2LjE5OTIxOGwtODQuNDcyNjU2LTg0LjE2MDE1Ni0yMS4xNzU3ODEgMjEuMjUzOTA2IDg0LjY5MTQwNiA4NC4zNzEwOTR6bTAgMCIgZmlsbD0iIzhjOGM4YyIvPjxwYXRoIGQ9Im00MDEuMzAwNzgxIDE2OC43NTM5MDZoLTM2LjcwNzAzMWw4NC42OTE0MDYtODQuMzcxMDk0LTIxLjE3NTc4MS0yMS4yNTM5MDYtODQuNDcyNjU2IDg0LjE2MDE1NnYtMzYuMTk5MjE4aC0zMHY4Ny42NjQwNjJoODcuNjY0MDYyem0wIDAiIGZpbGw9IiM4YzhjOGMiLz48cGF0aCBkPSJtMCAwdjUxMmg1MTJ2LTUxMnptNDgyIDQ4MmgtNDUydi00NTJoNDUyem0wIDAiIGZpbGw9IiM4YzhjOGMiLz48L3N2Zz4K")
  }
  .image-gallery-fullscreen-button.active:hover::before {
    transform: scale(0.9);
  }

  .image-gallery-play-button {
    left: 0;
  }
  .image-gallery-play-button::before {
    content: '';
  }
  .image-gallery-play-button.active::before {
    content: '';
  }

  .image-gallery-left-nav,
  .image-gallery-right-nav {
    color: ${colors.white};
    font-size: 5em;
    padding: 50px 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  .image-gallery-left-nav[disabled],
  .image-gallery-right-nav[disabled] {
    cursor: disabled;
    opacity: 0.6;
    pointer-events: none;
  }
  @media (max-width: 768px) {
    .image-gallery-left-nav,
    .image-gallery-right-nav {
      font-size: 3.4em;
      padding: 20px 15px;
    }
  }
  @media (max-width: 480px) {
    .image-gallery-left-nav,
    .image-gallery-right-nav {
      font-size: 2.4em;
      padding: 0 15px;
    }
  }

  .image-gallery-left-nav {
    left: 0;
  }
  .image-gallery-left-nav::before {
    content: '';
  }

  .image-gallery-right-nav {
    right: 0;
  }
  .image-gallery-right-nav::before {
    content: '';
  }

  .image-gallery-slides {
    line-height: 0;
    overflow: hidden;
    position: relative;
    white-space: nowrap;
  }

  .image-gallery-slide {
    background: ${colors.white};
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .image-gallery-slide.center {
    position: relative;
  }
  .image-gallery-slide img {
    width: 100%;
  }
  .image-gallery-slide .image-gallery-description {
    background: rgba(0, 0, 0, 0.4);
    bottom: 70px;
    color: ${colors.white};
    left: 0;
    line-height: 1;
    padding: 10px 20px;
    position: absolute;
    white-space: normal;
  }
  @media (max-width: 768px) {
    .image-gallery-slide .image-gallery-description {
      bottom: 45px;
      font-size: 0.8em;
      padding: 8px 15px;
    }
  }

  .image-gallery-bullets {
    bottom: 20px;
    left: 0;
    margin: 0 auto;
    position: absolute;
    right: 0;
    width: 80%;
    z-index: 4;
  }
  .image-gallery-bullets .image-gallery-bullets-container {
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .image-gallery-bullets .image-gallery-bullet {
    appearance: none;
    background-color: transparent;
    border: 1px solid ${colors.white};
    border-radius: 50%;
    box-shadow: 0 1px 0 ${colors.charcoalBlack};
    cursor: pointer;
    display: inline-block;
    margin: 0 5px;
    outline: none;
    padding: 5px;
  }
  @media (max-width: 768px) {
    .image-gallery-bullets .image-gallery-bullet {
      margin: 0 3px;
      padding: 3px;
    }
  }
  @media (max-width: 480px) {
    .image-gallery-bullets .image-gallery-bullet {
      padding: 2.7px;
    }
  }
  .image-gallery-bullets .image-gallery-bullet.active {
    background: ${colors.white};
  }

  .image-gallery-thumbnails-wrapper {
    position: relative;
  }
  .image-gallery-thumbnails-wrapper.left,
  .image-gallery-thumbnails-wrapper.right {
    display: inline-block;
    vertical-align: top;
    width: 108px;
  }
  @media (max-width: 768px) {
    .image-gallery-thumbnails-wrapper.left,
    .image-gallery-thumbnails-wrapper.right {
      width: 81px;
    }
  }
  .image-gallery-thumbnails-wrapper.left .image-gallery-thumbnails,
  .image-gallery-thumbnails-wrapper.right .image-gallery-thumbnails {
    height: 100%;
    width: 100%;
    left: 0;
    padding: 0;
    position: absolute;
    top: 0;
  }
  .image-gallery-thumbnails-wrapper.left
    .image-gallery-thumbnails
    .image-gallery-thumbnail,
  .image-gallery-thumbnails-wrapper.right
    .image-gallery-thumbnails
    .image-gallery-thumbnail {
    display: block;
    margin-right: 0;
    padding: 0;
  }
  .image-gallery-thumbnails-wrapper.left
    .image-gallery-thumbnails
    .image-gallery-thumbnail
    + .image-gallery-thumbnail,
  .image-gallery-thumbnails-wrapper.right
    .image-gallery-thumbnails
    .image-gallery-thumbnail
    + .image-gallery-thumbnail {
    margin-left: 0;
  }
  .image-gallery-thumbnails-wrapper.left {
    margin-right: 5px;
  }
  @media (max-width: 768px) {
    .image-gallery-thumbnails-wrapper.left {
      margin-right: 3px;
    }
  }
  .image-gallery-thumbnails-wrapper.right {
    margin-left: 5px;
  }
  @media (max-width: 768px) {
    .image-gallery-thumbnails-wrapper.right {
      margin-left: 3px;
    }
  }

  .image-gallery-thumbnails {
    overflow: hidden;
    padding: 5px 0;
  }
  @media (max-width: 768px) {
    .image-gallery-thumbnails {
      padding: 3px 0;
    }
  }
  .image-gallery-thumbnails .image-gallery-thumbnails-container {
    cursor: pointer;
    text-align: center;
    transition: transform 0.45s ease-out;
    white-space: nowrap;
  }

  .image-gallery-thumbnail {
    display: inline-block;
    border: 4px solid transparent;
    transition: border 0.3s ease-out;
    width: 100px;
  }
  @media (max-width: 768px) {
    .image-gallery-thumbnail {
      border: 3px solid transparent;
      width: 75px;
    }
  }
  .image-gallery-thumbnail + .image-gallery-thumbnail {
    margin-left: 2px;
  }
  .image-gallery-thumbnail img {
    vertical-align: middle;
    width: 100%;
  }
  .image-gallery-thumbnail.active {
    border: 4px solid ${colors.indigo};
  }
  @media (max-width: 768px) {
    .image-gallery-thumbnail.active {
      border: 3px solid ${colors.indigo};
    }
  }

  .image-gallery-thumbnail-label {
    color: ${colors.charcoalBlack};
    font-size: 1em;
  }
  @media (max-width: 768px) {
    .image-gallery-thumbnail-label {
      font-size: 0.8em;
    }
  }
  .manager-property .image-gallery-image {
    height: 250px;
  }
  .image-gallery-image {
    display: flex;
    height: 400px;
    text-align: center;
  }

  .fullscreen.image-gallery-content,
  .fullscreen.image-gallery-content .image-gallery-slide-wrapper,
  .fullscreen.image-gallery-content
    .image-gallery-slide-wrapper
    .image-gallery-swipe {
    height: 100%;
  }

  .fullscreen .image-gallery-slides,
  .fullscreen .image-gallery-slide.center,
  .fullscreen .image-gallery-slide.left,
  .fullscreen .image-gallery-slide.right {
    height: inherit;
  }

  .fullscreen .image-gallery-image {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100vw;
    height: 100vh;
  }
  .image-gallery-image img {
    max-width: 100%;
    max-height: 100%;
  }
  .fullscreen .image-gallery-image img,
  .image-gallery-image img,
  .fullscreen .image-gallery-image picture,
  .image-gallery-image picture {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }

  .image-gallery-index {
    background: rgba(0, 0, 0, 0.4);
    color: ${colors.white};
    line-height: 1;
    padding: 10px 20px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 4;
  }

  .image-gallery-wrapper {
    border: 1px solid ${colors.border};
    border-top: none;
  }

  @media screen and (max-width: 768px) {
    .image-gallery-index {
      font-size: 0.8em;
      padding: 5px 10px;
    }
  }
 
  .image-gallery.nexsite1-slide .image-gallery-image {    
    height: 31.25rem;
  }

  .image-gallery.nexsite1-slide .fullscreen .image-gallery-image{
    height: 100%;
  }  

  .image-gallery.nexsite1-slide .image-gallery-image img {
    object-fit:cover;
  }
  
  .image-gallery.nexsite1-slide .fullscreen .image-gallery-image img{
    object-fit:contain;    
  }
 
  .image-gallery.nexsite1-slide .fullscreen .image-gallery-image{
    height:fit-content;
  }
  
  .image-gallery.nexsite1-slide .image-gallery-thumbnail img{
    width:5.625rem;
    height:4.0625rem;
    object-fit:cover;
  }

  .image-gallery.nexsite1-slide .image-gallery-thumbnail.active{
    border:0.25rem solid ${colors.darkGray};
  }

  .image-gallery.nexsite1-slide .image-gallery-thumbnails-wrapper{
    padding:0 13% 0.625rem 13%;
    background-image:linear-gradient(to bottom, rgba(0, 0, 0, 0), ${colors.black});
    position: absolute;
    width: 100%;
    bottom: 0;
    z-index:10;
  }

  .image-gallery.nexsite1-slide .fullscreen .image-gallery-thumbnails-wrapper{
    display:none;
  }

  .image-gallery.nexsite1-slide .image-gallery-fullscreen-button{
    width:100%;
    height:100%;
    z-index:1;
  }
  
  .image-gallery.nexsite1-slide .image-gallery-fullscreen-button::before{
    display:none;
  }

  .image-gallery.nexsite1-slide .image-gallery-fullscreen-button.active::before{
    display:block;
  }
  
  .image-gallery-slide .image-gallery-image {
    opacity: 0;
  }
  .image-gallery-slide.center .image-gallery-image {
    opacity: 1;
  }
  .image-gallery-slide .image-gallery-image { opacity 0.2s ease-out !important; }

  @media (max-width: 49.3125rem) {
    .image-gallery.nexsite1-slide .image-gallery-thumbnails .image-gallery-thumbnails-container{
      display:none;      
    }
  }
  
`
